// extracted by mini-css-extract-plugin
export var box = "_7v-1";
export var checkboxRow = "_7v-8";
export var checked = "_7v-2";
export var descriptionSpacer = "_7v-a";
export var disabled = "_7v-3";
export var icon = "_7v-6";
export var input = "_7v-0";
export var labelSpacer = "_7v-9";
export var medium = "_7v-5";
export var small = "_7v-4";
export var text = "_7v-7";